import React from 'react';
import Route from '../Route';
import GeckoRequest from 'services/gecko-request';
import { resolve } from 'services/resolver';

import Automation from './Automation.jsx';
import Workflows from './Workflows.jsx';
import Workflow from './Workflow.jsx';
import Results from './Results';

const routes = new Route({
  path: '/automation',
  children: [
    {
      name: 'workflows',
      path: '/workflows',
      requires: ['admin', 'supervisor'],
      action: () => (
        <Automation>
          <Workflows />
        </Automation>
      ),
    },
    {
      name: 'restults',
      path: '/workflows/results',
      requires: ['admin', 'supervisor'],
      action: () => (
        <Automation>
          <Results />
        </Automation>
      ),
    },
    {
      name: 'workflow',
      path: '/workflows/:workflow_id',
      requires: ['admin', 'supervisor'],
      action: function (context) {
        return (
          <Automation>
            <Workflow workflowId={context.params.workflow_id} />
          </Automation>
        );
      },
    },
  ],
});

export default routes;
